export const DeliveryTruckIcon = ({
  color = "#0F2C52",
  size = 20,
}: {
  color?: string;
  size?: number;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1592_3796)">
        <path
          d="M19.375 11.25V5C19.375 4.66848 19.2433 4.35054 19.0089 4.11612C18.7745 3.8817 18.4565 3.75 18.125 3.75H8.125C7.79348 3.75 7.47554 3.8817 7.24112 4.11612C7.0067 4.35054 6.875 4.66848 6.875 5V10"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.875 10V5H4.375C3.38044 5 2.42661 5.39509 1.72335 6.09835C1.02009 6.80161 0.625 7.75544 0.625 8.75V13.75C0.625 14.0815 0.756696 14.3995 0.991117 14.6339C1.22554 14.8683 1.54348 15 1.875 15H2.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.625 10H3.125C3.45652 10 3.77446 9.8683 4.00888 9.63388C4.2433 9.39946 4.375 9.08152 4.375 8.75V5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.375 14.375C4.375 14.6212 4.4235 14.865 4.51773 15.0925C4.61195 15.32 4.75006 15.5267 4.92417 15.7008C5.09828 15.8749 5.30498 16.013 5.53247 16.1073C5.75995 16.2015 6.00377 16.25 6.25 16.25C6.49623 16.25 6.74005 16.2015 6.96753 16.1073C7.19502 16.013 7.40172 15.8749 7.57583 15.7008C7.74994 15.5267 7.88805 15.32 7.98227 15.0925C8.0765 14.865 8.125 14.6212 8.125 14.375C8.125 14.1288 8.0765 13.885 7.98227 13.6575C7.88805 13.43 7.74994 13.2233 7.57583 13.0492C7.40172 12.8751 7.19502 12.737 6.96753 12.6427C6.74005 12.5485 6.49623 12.5 6.25 12.5C6.00377 12.5 5.75995 12.5485 5.53247 12.6427C5.30498 12.737 5.09828 12.8751 4.92417 13.0492C4.75006 13.2233 4.61195 13.43 4.51773 13.6575C4.4235 13.885 4.375 14.1288 4.375 14.375Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.375 14.375C14.375 14.6212 14.4235 14.865 14.5177 15.0925C14.612 15.32 14.7501 15.5267 14.9242 15.7008C15.0983 15.8749 15.305 16.013 15.5325 16.1073C15.76 16.2015 16.0038 16.25 16.25 16.25C16.4962 16.25 16.74 16.2015 16.9675 16.1073C17.195 16.013 17.4017 15.8749 17.5758 15.7008C17.7499 15.5267 17.888 15.32 17.9823 15.0925C18.0765 14.865 18.125 14.6212 18.125 14.375C18.125 14.1288 18.0765 13.885 17.9823 13.6575C17.888 13.43 17.7499 13.2233 17.5758 13.0492C17.4017 12.8751 17.195 12.737 16.9675 12.6427C16.74 12.5485 16.4962 12.5 16.25 12.5C16.0038 12.5 15.76 12.5485 15.5325 12.6427C15.305 12.737 15.0983 12.8751 14.9242 13.0492C14.7501 13.2233 14.612 13.43 14.5177 13.6575C14.4235 13.885 14.375 14.1288 14.375 14.375Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 15H12.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1592_3796">
          <rect width="20" height="20" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};
